import { Pipe, PipeTransform } from "@angular/core";

import { ADPResourceService as ResourceService } from "digital-core";

@Pipe({
  name: "localNumber"
})
export class LocalNumberPipe implements PipeTransform {
  constructor(private resourcesService: ResourceService) {}

  transform(value: any, numberStyle: string): any {
    if (!value) {
      return "";
    }
    let options: any = {};
    options.style = numberStyle === "%" ? "percent" : "decimal";
    
    let result = Number(value).toLocaleString(
      this.resourcesService.getLocalizationSettings().ClientLocalLanguage,
      options
    );

    return result;
  }
}
